import type { Tokens } from '../../../../theming/types'
import type { BaseButtonProps } from '../BaseButton'

export default (config: {
  props: Pick<BaseButtonProps, 'kind' | 'disabled'>
  tokens: Tokens
}) => {
  const { props, tokens } = config
  const { kind } = config.props

  const kindStyles = {
    brand: {
      active: {
        backgroundColor: tokens.button.main.activeBackgroundColor,
      },
      color: {
        backgroundColor: tokens.button.main.defaultBackgroundColor,
        color: tokens.button.main.defaultTextColor,
      },
      disabled: {
        backgroundColor: tokens.button.main.defaultBackgroundColor,
        color: tokens.button.main.defaultTextColor,
      },
      hover: {
        backgroundColor: tokens.button.main.hoverBackgroundColor,
        color: tokens.button.main.defaultTextColor,
      },
    },
    primary: {
      active: {
        backgroundColor: tokens.button.primary.activeBackgroundColor,
      },
      color: {
        backgroundColor: tokens.button.primary.defaultBackgroundColor,
        color: tokens.button.primary.defaultTextColor,
      },
      disabled: {
        backgroundColor: tokens.button.primary.defaultBackgroundColor,
        color: tokens.button.primary.defaultTextColor,
      },
      hover: {
        backgroundColor: tokens.button.primary.hoverBackgroundColor,
        color: tokens.button.primary.defaultTextColor,
      },
    },
    secondary: {
      active: {
        backgroundColor: tokens.button.secondary.activeBackgroundColor,
        borderColor: tokens.button.secondary.defaultBorderColor,
      },
      color: {
        backgroundColor: tokens.button.secondary.defaultBackgroundColor,
        borderColor: tokens.button.secondary.defaultBorderColor,
        color: tokens.button.secondary.defaultTextColor,
      },
      disabled: {
        color: tokens.button.secondary.defaultTextColor,
        backgroundColor: tokens.button.secondary.defaultBackgroundColor,
      },
      hover: {
        backgroundColor: tokens.button.secondary.hoverBackgroundColor,
        borderColor: tokens.button.secondary.defaultBorderColor,
        color: tokens.button.secondary.defaultTextColor,
      },
    },
    tertiary: {
      active: {
        backgroundColor: tokens.button.tertiary.activeBackgroundColor,
      },
      color: {
        backgroundColor: tokens.button.tertiary.defaultBackgroundColor,
        color: tokens.button.tertiary.defaultTextColor,
      },
      disabled: {
        color: tokens.button.tertiary.defaultTextColor,
        backgroundColor: tokens.button.tertiary.defaultBackgroundColor,
      },
      hover: {
        backgroundColor: tokens.button.tertiary.hoverBackgroundColor,
        color: props.disabled
          ? tokens.ctaBgColorPrimaryHover
          : tokens.button.tertiary.defaultTextColor,
      },
    },
    danger: {
      active: {
        backgroundColor: tokens.button.danger.activeBackgroundColor,
      },
      color: {
        backgroundColor: tokens.button.danger.defaultBackgroundColor,
        color: tokens.button.danger.defaultTextColor,
      },
      disabled: {
        color: tokens.button.danger.defaultTextColor,
        backgroundColor: tokens.button.danger.defaultBackgroundColor,
      },
      hover: {
        backgroundColor: tokens.button.danger.hoverBackgroundColor,
        color: tokens.button.danger.defaultTextColor,
      },
    },
  }

  return {
    button: {
      default: {
        ...kindStyles[kind!].color,
        borderRadius: '2px',

        '&:hover': { ...kindStyles[kind!].hover },
        '&:active, &[aria-expanded="true"]': { ...kindStyles[kind!].active },
        '&:disabled': {
          ...kindStyles[kind!].disabled,
        },
      },
    },
  } as const
}
